var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm._l(
        _vm.rowData[_vm.fieldData.fieldCode],
        function (coloritem3, colorIndex) {
          return _c(
            "span",
            {
              key: colorIndex,
              staticStyle: {
                "margin-right": "5px",
                "text-decoration": "underline",
                cursor: "pointer",
              },
              on: {
                click: function ($event) {
                  return _vm.getImgList(coloritem3.colorId)
                },
              },
            },
            [_vm._v(_vm._s(coloritem3.colorName))]
          )
        }
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "modal-append-to-body": false,
            center: "",
            title: "图片详情",
            visible: _vm.showImgVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showImgVisible = $event
            },
          },
        },
        [
          _vm.imgList && _vm.imgList.length < 1
            ? _c(
                "span",
                { staticStyle: { display: "block", "text-align": "center" } },
                [_vm._v("暂无图片")]
              )
            : _c(
                "el-carousel",
                { attrs: { height: "300px" } },
                _vm._l(_vm.imgList, function (imgItem, imgImdex) {
                  return _c("el-carousel-item", { key: imgImdex }, [
                    _c("img", {
                      attrs: { src: _vm.imgPrefix + imgItem.url, alt: "" },
                    }),
                  ])
                }),
                1
              ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }